import React, { useState, useEffect, useRef } from 'react';
import api from '../../services/api';

const QUICK_QUESTIONS = [
  '¿Cuánto cobra Guarapo de fee?',
  '¿Cómo funciona el escrow?',
  '¿Por qué no llegó mi orden?',
  '¿Cómo verifico mi identidad?',
  '¿Cómo puedo ser agente?',
];

function Message({ msg }) {
  const isUser = msg.role === 'user';
  return (
    <div style={{ display: 'flex', justifyContent: isUser ? 'flex-end' : 'flex-start', marginBottom: 12 }}>
      {!isUser && (
        <div style={{ width: 32, height: 32, borderRadius: '50%', background: 'linear-gradient(135deg,#c94a1e,#8b2e0e)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, flexShrink: 0, marginRight: 8, marginTop: 2 }}>
          🤖
        </div>
      )}
      <div style={{
        maxWidth: '78%',
        padding: '10px 14px',
        borderRadius: isUser ? '14px 14px 4px 14px' : '14px 14px 14px 4px',
        background: isUser ? '#c94a1e' : '#fff',
        color: isUser ? '#fff' : '#0f0d0b',
        fontSize: 14,
        lineHeight: 1.6,
        border: isUser ? 'none' : '1px solid #e2dbd0',
        whiteSpace: 'pre-wrap',
      }}>
        {msg.content}
      </div>
    </div>
  );
}

export default function SupportChat({ onClose }) {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [sessionId, setSessionId] = useState(null);
  const bottomRef = useRef(null);

  useEffect(() => {
    // Welcome message
    setMessages([{
      role: 'assistant',
      content: '👋 Hola! Soy el asistente de Guarapo. Puedo ayudarte con tus órdenes, fees, escrow y cualquier problema que tengas. ¿En qué puedo ayudarte?',
    }]);
  }, []);

  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const sendMessage = async (text) => {
    if (!text.trim() || loading) return;
    const userMsg = { role: 'user', content: text };
    setMessages(prev => [...prev, userMsg]);
    setInput('');
    setLoading(true);

    try {
      const res = await api.post('/api/v1/support/chat', {
        message: text,
        session_id: sessionId,
      });
      setSessionId(res.data.session_id);
      setMessages(prev => [...prev, { role: 'assistant', content: res.data.response }]);
    } catch (e) {
      setMessages(prev => [...prev, {
        role: 'assistant',
        content: 'Lo siento, hubo un error. Por favor intenta de nuevo o escribe a soporte@guarapo.app',
      }]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      position: 'fixed', bottom: 24, right: 24,
      width: 380, height: 560,
      background: '#fff', borderRadius: 20,
      boxShadow: '0 8px 48px rgba(0,0,0,.18)',
      display: 'flex', flexDirection: 'column',
      zIndex: 1000, overflow: 'hidden',
      border: '1px solid #e2dbd0',
    }}>
      {/* Header */}
      <div style={{ background: 'linear-gradient(135deg,#c94a1e,#8b2e0e)', padding: '14px 18px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexShrink: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{ width: 36, height: 36, borderRadius: '50%', background: 'rgba(255,255,255,.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18 }}>🤖</div>
          <div>
            <div style={{ fontFamily: 'Georgia,serif', fontSize: 15, color: '#fff', fontWeight: 700 }}>Soporte Guarapo</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
              <div style={{ width: 7, height: 7, borderRadius: '50%', background: '#4ade80' }} />
              <span style={{ fontSize: 11, color: 'rgba(255,255,255,.6)' }}>AI · Responde al instante</span>
            </div>
          </div>
        </div>
        {onClose && (
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,.6)', fontSize: 20, cursor: 'pointer' }}>✕</button>
        )}
      </div>

      {/* Messages */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '16px 14px', background: '#f9f6f1' }}>
        {messages.map((msg, i) => <Message key={i} msg={msg} />)}

        {loading && (
          <div style={{ display: 'flex', gap: 8, marginBottom: 12 }}>
            <div style={{ width: 32, height: 32, borderRadius: '50%', background: 'linear-gradient(135deg,#c94a1e,#8b2e0e)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, flexShrink: 0 }}>🤖</div>
            <div style={{ padding: '10px 14px', borderRadius: '14px 14px 14px 4px', background: '#fff', border: '1px solid #e2dbd0', display: 'flex', gap: 4, alignItems: 'center' }}>
              {[0,1,2].map(i => (
                <div key={i} style={{ width: 6, height: 6, borderRadius: '50%', background: '#c94a1e', animation: `bounce 1s ${i*0.15}s infinite` }} />
              ))}
            </div>
          </div>
        )}

        {/* Quick questions */}
        {messages.length === 1 && (
          <div style={{ marginTop: 8 }}>
            <div style={{ fontSize: 11, color: '#b0a090', marginBottom: 8, textAlign: 'center' }}>Preguntas frecuentes</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
              {QUICK_QUESTIONS.map((q, i) => (
                <button key={i} onClick={() => sendMessage(q)}
                  style={{ padding: '8px 12px', borderRadius: 20, border: '1px solid #e2dbd0', background: '#fff', fontSize: 12, cursor: 'pointer', textAlign: 'left', color: '#4a4035', transition: 'all .15s' }}
                  onMouseOver={e => e.currentTarget.style.borderColor = '#c94a1e'}
                  onMouseOut={e => e.currentTarget.style.borderColor = '#e2dbd0'}>
                  {q}
                </button>
              ))}
            </div>
          </div>
        )}
        <div ref={bottomRef} />
      </div>

      {/* Input */}
      <div style={{ padding: '10px 12px', background: '#fff', borderTop: '1px solid #e2dbd0', display: 'flex', gap: 8, flexShrink: 0 }}>
        <textarea
          value={input}
          onChange={e => setInput(e.target.value)}
          onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendMessage(input); } }}
          placeholder="Escribe tu pregunta..."
          style={{ flex: 1, padding: '9px 12px', border: '1px solid #e2dbd0', borderRadius: 10, fontSize: 14, outline: 'none', resize: 'none', minHeight: 36, maxHeight: 90, lineHeight: 1.4, fontFamily: 'inherit' }}
          rows={1}
          disabled={loading}
        />
        <button onClick={() => sendMessage(input)} disabled={loading || !input.trim()}
          style={{ width: 36, height: 36, borderRadius: 8, border: 'none', background: (loading || !input.trim()) ? '#e2dbd0' : '#c94a1e', color: '#fff', cursor: (loading || !input.trim()) ? 'not-allowed' : 'pointer', fontSize: 16, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          →
        </button>
      </div>

      <style>{`
        @keyframes bounce { 0%,100%{transform:translateY(0)} 50%{transform:translateY(-4px)} }
      `}</style>
    </div>
  );
}
